import React, { VFC } from 'react';
import styled from 'styled-components';

type Props = React.ImgHTMLAttributes<HTMLImageElement>;

const StyledImg = styled.img<Props>`
  max-width: 54px;
  object-fit: contain;
  aspect-ratio: 3/4;
  border: 1px solid #e0e0e0;
  padding: 12px;
  border-radius: 4px;
`;

const ProductImage: VFC<Props> = ({ ...props }) => <StyledImg {...props} />;

export default ProductImage;
